import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, switchMap, take } from "rxjs";

import { LocalizationService } from "@app/core/services/localization.service";

@Injectable()
export class LocaleInterceptor<T> implements HttpInterceptor {
  private readonly localizationService = inject(LocalizationService);

  intercept(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    return this.localizationService.language$.pipe(
      take(1),
      switchMap((lang) => {
        const cloned = req.clone({
          setHeaders: {
            "Accept-Language": lang
          }
        });

        return next.handle(cloned);
      })
    );
  }
}
